import request from './request';

/**
 * 获取视频列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回视频列表数据
 */
export function getVideoList(params = {}) {
  return request({
    url: '/api/video/index',
    method: 'get',
    params
  });
}

/**
 * 获取视频详情
 * @param {String|Number} id 视频ID
 * @returns {Promise} 返回视频详情数据
 */
export function getVideoDetail(id) {
  return request({
    url: `/api/video/detail?id=${id}`,
    method: 'get'
  });
}

// 添加获取分类列表的方法
export function getCategoryList() {
  return request({
    url: '/api/category/index',
    method: 'get'
  });
}

/**
 * 获取视频评论列表
 * @param {Object} params 查询参数
 * @param {String|Number} params.video_id 视频ID（必填）
 * @param {Number} [params.page=1] 页码
 * @param {Number} [params.limit=10] 每页数量
 * @param {String} [params.order='createtime DESC'] 排序方式
 * @returns {Promise} 返回评论列表数据
 */
export function getVideoComments(params) {
  return request({
    url: '/api/video_comment/index',
    method: 'get',
    params
  });
}

/**
 * 发表视频评论
 * @param {Object} data 评论数据
 * @param {String|Number} data.video_id 视频ID（必填）
 * @param {String} data.content 评论内容（必填）
 * @returns {Promise} 返回评论结果
 */
export function addVideoComment(data) {
  const { token, ...commentData } = data;
  return request({
    url: '/api/video_comment/add',
    method: 'post',
    headers: {
      'token': token
    },
    data: commentData
  });
}

/**
 * 获取礼物列表
 * @returns {Promise} 返回礼物列表数据
 */
export function getGiftList() {
  return request({
    url: '/api/gift/index',
    method: 'get'
  });
}

/**
 * 打赏礼物
 * @param {Object} data 打赏数据
 * @param {String|Number} data.video_id 视频ID（必填）
 * @param {String|Number} data.gift_id 礼物ID（必填）
 * @param {Number} [data.gift_count=1] 礼物数量（选填，默认1）
 * @returns {Promise} 返回打赏结果
 */
export function rewardGift(data) {
  return request({
    url: '/api/video_reward/reward',
    method: 'post',
    data
  });
}

// 获取关于我们信息
export function getAboutInfo() {
  return request({
    url: '/api/about/index',
    method: 'get'
  })
}

/**
 * 搜索视频
 * @param {String} keyword 搜索关键词
 * @returns {Promise} 返回搜索结果
 */
export function searchVideo(keyword) {
  return request({
    url: '/api/video/search',
    method: 'get',
    params: { keyword }
  });
} 